module.exports = __webpack_public_path__ + "static/media/smileSmall.71b58687.svg";